export default "__VITE_ASSET__C89c5wc5__"